<template>
  <b-row>
    <div class="col-12 col-sm-9">
      <section class="content">
        <b-card class="mb-3" :header="heading" no-body>
          <div class="card-body">
            <div class="form">
              <div class="form-row">
                <div class="col-md-12">
                  <b-form-group label="For Project:">
                    <b-form-select :options="projectsList" v-model="itemForm.projectId" />
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Name:">
                    <b-form-input v-model="itemForm.name" />
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Slug:">
                    <b-form-input v-model="itemForm.slug" placeholder="Leave empty to autogen" />
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group label="Parent Group:">
                    <b-form-select :options="knowGroupsToPick" v-model="itemForm.parentGroupId" />
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group label="Description:">
                    <b-form-textarea v-model="itemForm.description"></b-form-textarea>
                  </b-form-group>
                </div>
                <!---<div class="col-md-12">
                    <b-form-group
                      label="Roles That Can Access This:"
                    >
                      <div class="border multicheckbox">
                        <label
                          v-for="itm in possibleRolesToPick"
                          :key="itm.value"
                          :for="'selItem-' + itm.value"
                          class="multicheckbox-item"
                        >
                          <input
                            :id="'selItem-' + itm.value"
                            v-model="itemForm.visibleToRoles"
                            type="checkbox"
                            class="d-none"
                            :name="'selItem-' + itm.value"
                            :value="itm.value"
                          />
                          <span>{{ itm.text }}</span>
                        </label>
                      </div>
                    </b-form-group>
                </div>-->
              </div>
            </div>
          </div>
        </b-card>
      </section>
    </div>
    <aside class="col-12 col-sm-3">
      <b-card header="Actions">
        <button
          class="btn btn-block btn-primary"
          type="submit"
          @click="SaveForm"
        >
          Save Changes
        </button>
        <router-link
          class="mt-2 btn btn-block btn-danger"
          :to="{ name: 'Admin.Knowledgebase.Groups.Index' }"
        >
          Cancel
        </router-link>
      </b-card>
    </aside>
  </b-row>
</template>

<script>
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'Admin.Knowledgebase.Groups.Form',
  mixins: [crudMixinGen('docs/knowledgebaseGroups'), myCommonDataMixin],
  props: {
    id: {
      type: String,
      default: '',
      required: false
    }
  },

  data: () => ({
    heading: 'Knowledgebase Group Form',
    possibleRolesToPick: [
      {value: 'developer', text: 'Developer'},
      {value: 'superadmin', text: 'Superadmin'},
      {value: 'admin', text: 'Admin / Enterprise'},
      {value: 'manager', text: 'Logistics'},
      {value: 'warehouse-manager', text: 'Warehouse Manager'},
      {value: 'manufacturing-manager', text: 'Manufacturing'},
      {value: 'fourpl-manager', text: '4PL Partners'},
      {value: 'finance-manager', text: 'Finance'},

      {value: 'brand-user', text: 'Clients'},
    ],
    knowGroups: [],
    knowGroupsToPick: []
  }),

  computed: {
  },

  watch: {
  },

  mounted() {
    this.loadDocsGroups();
    this.ResetForm();
    if (this.id) {
      this.LoadItem(this.id)
      .then((resp) => {
      })
    } else {
      this.readyToLoad = true;
    }
  },

  methods: {
    loadDocsGroups() {
      this.$http
        .get('/api/docs/knowledgebaseGroups')
        .then(resp => {
            this.knowGroupsToPick = [{value: null, text: 'None'}];
            this.knowGroups = resp.data;
            this.knowGroups.forEach((grop) => {
              if(grop.id != this.id)
                this.knowGroupsToPick.push({value: grop.id, text: grop.name});
            })
        })
        .catch(err => {});
    },

    Slugify(str) {
      return str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
    },

    SaveForm() {
      this.itemForm.slug = this.Slugify(this.itemForm.name);
      this.SaveItem()
      .then(resp => {
        if (resp.status) {
          if (resp.id) {
            this.$swal({ title: 'Group Was Saved.', icon: 'info' });
          } else {
            this.$swal({ title: 'New Group was added.', icon: 'success' });
          }
          this.$router.push({
            name: 'Admin.Knowledgebase.Groups.Index'
          });
        } else {
          this.$swal({ title: resp.errorMessage, icon: 'error' });
        }
      })
      .catch(err => {
        console.error('saved po err', err);
      });
    }
  }
};
</script>
